import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MirrorOfTheMindModule from "./modules/mirror-of-the-mind/MirrorOfTheMindModule";
import BookPresentation from "./modules/mirror-of-the-mind/BookPresentation";
import ProductInformation from "./modules/mirror-of-the-mind/ProductInformation";
import PurchaseComplete from "./modules/mirror-of-the-mind/PurchaseComplete";
import AURFullBookReader from "./modules/mirror-of-the-mind/AURFullBookReader";
import AboutPage from "./modules/mirror-of-the-mind/AboutPage";
import AURVisualEnvironment from "./modules/shared/AURVisualEnvironment";
import InfoPage from "./modules/legal/InfoPage";
import ScrollToTop from "./components/ScrollToTop";
import { LanguageProvider } from "./modules/shared/LanguageContext";
import LanguageSelector from "./modules/shared/LanguageSelector";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <ScrollToTop />
        <AURVisualEnvironment>
          <Routes>
          <Route
            path="/"
            element={
              <>
                <MirrorOfTheMindModule />
                <LanguageSelector />
              </>
            }
          />
          <Route
            path="/mirror-of-the-mind"
            element={
              <>
                <MirrorOfTheMindModule />
                <LanguageSelector />
              </>
            }
          />
          <Route
            path="/mirror-of-the-mind/about"
            element={<AboutPage />}
          />
          <Route
            path="/mirror-of-the-mind/book"
            element={<BookPresentation />}
          />
          <Route
            path="/mirror-of-the-mind/book/product"
            element={<ProductInformation />}
          />
          <Route
            path="/mirror-of-the-mind/book/purchase/complete"
            element={<PurchaseComplete />}
          />
          <Route
            path="/mirror-of-the-mind/book/read"
            element={<AURFullBookReader />}
          />
          <Route path="/legal/:slug" element={<InfoPage />} />
          </Routes>
        </AURVisualEnvironment>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
